var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
      _c(
        "v-expansion-panels",
        {
          staticClass: "mt-2 mb-4",
          attrs: { multiple: "", accordion: "", flat: "", focusable: "" },
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        [
          _c("r-item-panel", {
            attrs: { items: _vm.value.items, title: "Items", amount: true },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "items", $event)
              },
            },
          }),
          _c("r-currency-panel", {
            attrs: { items: _vm.value.money, title: "Currency" },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "money", $event)
              },
            },
          }),
          _c("r-reward-package-panel", {
            attrs: { items: _vm.value.packages, title: "Packages" },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "packages", $event)
              },
            },
          }),
          _c("r-card-panel", {
            attrs: { items: _vm.value.cards, title: "Cards" },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "cards", $event)
              },
            },
          }),
          _c("r-card-package-panel", {
            attrs: { items: _vm.value.cardPackages, title: "Card Packages" },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "cardPackages", $event)
              },
            },
          }),
          _c("r-currency-correction-panel", {
            attrs: {
              items: _vm.value.currencyCorrection,
              title: "Currency Correction",
            },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "currencyCorrection", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6", sm: "6" } },
            [
              _c("r-avatar-dropdown", {
                attrs: { model: _vm.model.avatar, clearable: true },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.model, "avatar", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }